import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from '../../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import style from './HamburgerCloseIcon.module.css.js';

const HamburgerCloseIcon = ({ className, open, onClick, }) => {
    return (jsxs("div", { className: classNames(style.icon, open && style.open, className), onClick: onClick, children: [jsx("span", {}), jsx("span", {}), jsx("span", {})] }));
};

export { HamburgerCloseIcon };
//# sourceMappingURL=HamburgerCloseIcon.js.map
